import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveryTypeTranslationPipe } from './delivery-type-translation.pipe';

@NgModule({
  declarations: [DeliveryTypeTranslationPipe],
  imports: [CommonModule],
  exports: [DeliveryTypeTranslationPipe]
})
export class DeliveryTypeTranslationPipeModule {}
